import { appConfig } from '../config/appConfig';
import { locales } from '../config/localesConfig';

export default class Localization {
    static getSupportedLocales() {
        const supportedLocalesList = appConfig.supportedLocales.split(',');
        return supportedLocalesList;
    }

    static getPrimaryLocale() {
        const primaryLocale = Localization.getSupportedLocales()[0];
        return primaryLocale;
    }

    static enableLanguageOptions() {
        return appConfig.languageOption === 'enabled';
    }

    static getCountrySupportedLanguageOptions() {
        const supportedLocales = Localization.getSupportedLocales();
        return supportedLocales.map((locale) => {
            if (!Object.hasOwn(locales, locale)) {
                throw new Error(
                    `${locale} does not exist in list of app locales. Make sure you include item in list of locales in localeConfig.js file`
                );
            }

            return {
                value: locale,
                dir: locales[locale].rtl ? 'rtl' : 'ltr'
            };
        });
    }
}
